export const environment = {
  production: false,
  providers: 'app',
  config: {
    tenant: '',
    clientId: '',
    authority: '',
    redirectUri: '',
  },
};
